export const RESULTS_PERSONA_IDS = [
	"neutral",
	"analyst",
	"executive",
	"play_by_play",
	"pirate",
	"witty",
] as const;

export type ResultsPersonaId = (typeof RESULTS_PERSONA_IDS)[number];

export function isResultsPersonaId(s: string): s is ResultsPersonaId {
	return (RESULTS_PERSONA_IDS as readonly string[]).includes(s);
}
